import styled from 'styled-components';

import GroupSVG from '../../../../assets/icons/secondary/3 User.svg';
import CalendarSVG from '../../../../assets/icons/secondary/Calendar.svg';
import {getColor, ms, square} from '../../../../styles';
import {View} from '../../../../uikit/View';

export const Container = styled(View)`
  flex: 1;
  flex-direction: column;
  row-gap: ${ms(12)};
  padding: ${ms(16)};
  border-radius: ${ms(10)};
  border: 1px solid ${getColor('border2')};
`;

export const Row = styled(View)`
  flex-direction: row;
  align-items: center;
  column-gap: ${ms(8)};
`;

export const GroupIcon = styled(GroupSVG).attrs(p => ({
  fill: getColor('icon3')(p),
}))`
  ${square(20)};
`;

export const CalendarIcon = styled(CalendarSVG).attrs(p => ({
  fill: getColor('icon3')(p),
}))`
  ${square(20)};
`;
